import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=981c3620&scoped=true"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"
import style0 from "./Recipe.vue?vue&type=style&index=0&id=981c3620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981c3620",
  null
  
)

export default component.exports